import * as React from 'react';
import { DropdownItem } from 'ui/common/dropdown-menu/dropdown-menu-item';
import { ExpandableBox } from 'app/area/reports/components/expandable-box';
import { mapToMenuItem, DropdownField } from 'app/area/reports/components/dropdown-field';
import { ComplexValue } from 'ui';
import { SelectItem } from 'app/area/reports/types';

interface AggregationFieldComponentProps {
  aggregateFunctionOptions: SelectItem[];
  uomSetOptions: SelectItem[];
  selectedAggregationField: ComplexValue<number>;
  selectedAggregationFunction: ComplexValue<number>;
  selectedUomSet: ComplexValue<number>;
  onSelect: (aggregateFunction: ComplexValue<number>, uomSet: ComplexValue<number>) => void;
  onRemove: () => void;
  textRemove: string;
  textHowToAggregate: string;
  textUomSet: string;
}

class AggregationFieldComponent extends React.Component<AggregationFieldComponentProps, {}> {

  private menuItemsForAggregation = (): DropdownItem[] => {
    const handleOnRemove = () => {
      this.props.onRemove();
    };
    return [{
      value: '1',
      description: this.props.textRemove,
      onClick: handleOnRemove
    }];
  };

  public render(): JSX.Element {
    const {
      selectedAggregationField,
      selectedAggregationFunction,
      selectedUomSet,
      aggregateFunctionOptions,
      uomSetOptions,
      onSelect,
      textHowToAggregate,
      textUomSet
    } = this.props;

    const selectedAggregateFunctionDropDown = selectedAggregationFunction?.value &&
      mapToMenuItem(selectedAggregationFunction);
    const selectedUomSetDropDown = selectedUomSet?.value && 
      mapToMenuItem(selectedUomSet);
    const dropdownOptions = aggregateFunctionOptions.map(
      item => mapToMenuItem(item, () => onSelect(item as ComplexValue<number>, selectedUomSet))
    );
    const uomOptions = uomSetOptions.map(
      item => mapToMenuItem(item, () => onSelect(selectedAggregationFunction, item as ComplexValue<number>) 
    ));

    const title = selectedAggregationField?.allLevelDescription || selectedAggregationField?.description;

    return (<ExpandableBox title={title} menuItems={this.menuItemsForAggregation()}>
      <DropdownField
        title={textHowToAggregate}
        selectedItem={selectedAggregateFunctionDropDown}
        options={dropdownOptions}
      />
      {!!uomOptions.length && <DropdownField 
        title={textUomSet}
        selectedItem={selectedUomSetDropDown}
        options={uomOptions}
      />}
    </ExpandableBox>);
  }
}

export const AggregationField = AggregationFieldComponent;
